__turbopack_context__.v({
  "button": "Signup-module__asU1GW__button",
  "form": "Signup-module__asU1GW__form",
  "input": "Signup-module__asU1GW__input",
});
